import React, {useEffect, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../../components/template-default";
import Card from "../../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import {print} from "../components/print";
import SelectComponent from "../../../components/select-component";
import Button from "../../../components/button";
import {FaPrint} from "react-icons/fa";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import TruncateCellRenderer from "../../../components/cell-renderer/truncate-cell-renderer";
import useFetchData from "../../cameras/hooks/use-fetch-data";
import useSse from "../../cameras/hooks/use-sse";


const NocReport = () => {
    const [filters, setFilters] = useState({project:""});
    const [showNoc, setShowNoc] = useState([]);
    const handleSelect = (id, value) => setFilters(prev => ({...prev, [id]: value}));

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const {hash} = useFetchData();

    const {noc} = useSse(hash, undefined, true);

    const gridRef = useRef();

    const [columnDefs] = useState([
        { field: "status", headerName: "Status", width: 100, cellClass: "justify-center"},
        { field: "capturePlaceName", headerName: "Ponto de coleta", width: 300},
        { field: "laneType", headerName: "Tipo", flex: 1},
        { field: "lanes", headerName: "Faixas", width: 70 },
        { field: "description", headerName: "Observações", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 400 }
    ]);

    const {data: projectsOpt} = useQuery({
        queryFn: () => projectService.options().then(({data}) => data),
        queryKey: ["projectsOpt"]
    });

    const handlePrint = () => {
        if (gridRef.current) {
            const title = `RELATÓRIO NOC - ${filters.project.label}`;
            print(gridRef, columnDefs, title, "");
        }
    }

    useEffect(() => {
        setShowNoc([])

        if (!noc) return;
        if (!filters.project?.code) return;
        const projectNoc = noc.find(value => value.ibge === filters.project.code);

        let reportNoc = projectNoc ? projectNoc.noc : []
        if (reportNoc.length > 0){
            reportNoc.map(item => {
                if(item.status === "ACTIVE") item.status = "Online"
                if(item.status === "ERROR") item.status = "Offline"
                if(item.status === "WARNING") item.status = "Alerta"
                if(item.lanes.length > 0) item.laneType = [...new Set(item.lanes.map(lane => lane.type))].join(", ")
                if(typeof item.lanes == "object") item.lanes = item.lanes.length

                return item
            });

            setShowNoc(reportNoc)
        }
    }, [filters, hash, noc]);

    return (
        <TemplateDefault title="Relatório de Noc">
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className="col-span-4 text-gray-900">
                        <SelectComponent
                            instanceId="project"
                            label="Projeto"
                            options={projectsOpt ?? []}
                            value={filters.project}
                            onChange={(value) => handleSelect("project", value)}
                            name="project"
                        />
                    </div>
                    <div className="col-span-7"></div>
                    <Button col={"col-span-1"} onClick={handlePrint}>
                        <FaPrint/>
                    </Button>
                </div>

                <div className={"ag-theme-quartz grid mt-4 report-table"} style={{height: "calc(100vh - 159px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={showNoc}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default NocReport;
